
//help here : http://www.babylscript.com/translations.html

// de - German
// en - English
// fr - French
// id - Indonesian
// it - Italian
// pl - Polish
// pt - Portuguese
// ro - Romanian
// es - Spanish
// ca - Catalan
// tr - Turkish


const pseudoCodeWords = {
    repeat: {
        fr: 'répète',
        en: 'repeat',
        de: 'wiederhole',
        id: 'ulangi',
        it: 'ripetere',
        pt: 'repetir',
        ro: 'repetă',
        es: 'repitelo',
        tr: 'tekrarla',
        pl: 'powtórz',
        ca: 'repeteix'
    },
    if: {
        fr: 'si',
        en: 'if',
        de: 'wenn',
        id: 'jika',
        it: 'se',
        pt: 'se',
        ro: 'dacă',
        es: 'si',
        tr: 'eğer',
        pl: 'jeżeli',
        ca: 'si'
    },
    else: {
        fr: 'sinon',
        en: 'else',
        de: 'sonst',
        id: 'lainnya',
        it: 'oppure',
        pt: 'senão',
        ro: 'altfel',
        es: 'sino',
        tr: 'değilse',
        pl: 'inaczej',
        ca: 'si no'
    },
    while: {
        fr: 'tant que',
        en: 'while',
        de: 'solange',
        id: 'selagi',
        it: 'mentre',
        pt: 'enquanto',
        ro: 'câttimp',
        es: 'mientras',
        tr: 'iken',
        pl: 'dopóki',
        ca: 'mentre'
    },
    function: {
        fr: 'fonction',
        en: 'function',
        de: 'funktion',
        id: 'fungsi',
        it: 'funzione',
        pt: 'função',
        ro: 'funcție',
        es: 'función',
        tr: 'işlev',
        pl: 'funkcja',
        ca: 'funció'
    }
}


const otherWords = {
    right: {
        fr: 'droite',
        en: 'right',
        de: 'rechts',
        id: 'kanan',
        it: 'destra',
        pt: 'direita',
        ro: 'dreapta',
        es: 'derecha',
        tr: 'sağ',
        pl: 'prawo',
        ca: 'dreta'
    },
    left: {
        fr: 'gauche',
        en: 'left',
        de: 'links',
        id: 'kiri',
        it: 'sinistra',
        pt: 'esquerda',
        ro: 'stânga',
        es: 'izquierda',
        tr: 'sol',
        pl: 'lewo',
        ca: 'esquerra'
    },
    up: {
        fr: 'haut',
        en: 'up',
        de: 'oben',
        id: 'atas',
        it: 'l’alto',
        pt: 'cima',
        ro: 'sus',
        es: 'arriba',
        tr: 'yukarı',
        pl: 'góra',
        ca: 'amunt'
    },
    down: {
        fr: 'bas',
        en: 'down',
        de: 'unten',
        id: 'bawah',
        it: 'basso',
        pt: 'baixo',
        ro: 'jos',
        es: 'abajo',
        tr: 'aşağı',
        pl: 'dół',
        ca: 'avall'
    },
    again: {
        fr: 'encore',
        en: 'again',
        de: 'nochmal',
        id: 'lagi',
        it: 'ancora',
        pt: 'outraVez',
        ro: 'dinNou',
        es: 'otraVez',
        tr: 'tekrar',
        pl: 'ponownie',
        ca: 'torna-hi'
    },
    do_you_want_help: {
        fr: 'Voulez-vous de l\'aide ?',
        en: 'Do you want some help ?',
        de: 'Möchten Sie Hilfe ?',
        id: 'Apakah Anda ingin bantuan ?',
        it: 'Vuoi un po\' di aiuto ?',
        pt: 'Você quer ajuda ?',
        ro: 'Vrei ajutor ?',
        es: '¿Quieres ayuda?',
        tr: 'Yardım ister misiniz ?',
        pl: 'Czy chcesz pomocy?',
        ca: 'Vols ajuda?'
    },
    are_you_sure: {
        fr: 'Êtes-vous sûr ?',
        en: 'Are you sure ?',
        de: 'Sind Sie sicher ?',
        id: 'apakah kamu yakin ?',
        it: 'Sei sicuro ?',
        pt: 'Você tem certeza ?',
        ro: 'Esti sigur ?',
        es: 'Estas seguro?',
        tr: 'Emin misiniz ?',
        pl: 'Czy jesteś pewna/y?',
        ca: "N'estàs segur?"
    },
    yes: {
        fr: 'Oui',
        en: 'Yes',
        de: 'Ja',
        id: 'Ya',
        it: 'Sì',
        pt: 'Sim',
        ro: 'Da',
        es: 'Sí',
        tr: 'Evet',
        pl: 'Tak',
        ca: 'Sí'
    },
    no: {
        fr: 'Non',
        en: 'No',
        de: 'Nein',
        id: 'Tidak',
        it: 'No',
        pt: 'Não',
        ro: 'Nu',
        es: 'No',
        tr: 'Hayır',
        pl: 'Nie',
        ca: 'No'
    },
    cancel: {
        fr: 'Annuler',
        en: 'Cancel',
        de: 'Abbrechen',
        id: 'Batal',
        it: 'Annulla',
        pt: 'Cancelar',
        ro: 'Anulați',
        es: 'Cancelar',
        tr: 'Iptal',
        pl: 'anuluj',
        ca: 'Cancel·la'
    },
    reset: {
        fr: 'Reset',
        en: 'Reset',
        de: 'Reset',
        id: 'Reset',
        it: 'Reset',
        pt: 'Restabelecer',
        ro: 'Restabili',
        es: 'Reiniciar',
        tr: 'Sıfırla',
        pl: 'Zresetuj',
        ca: 'Restableix'
    },
    the_end: {
        fr: 'Fin',
        en: 'The end',
        de: 'Ende',
        id: 'Tamat',
        it: 'Fine',
        pt: 'O fim',
        ro: 'Sfarsit',
        es: 'El fin',
        tr: 'Bu son',
        pl: 'Koniec',
        ca: 'Fi'
    },
    toTheRight: {
        fr: 'versLaDroite',
        en: 'toTheRight',
        de: 'nachRechts',
        id: 'keKanan',
        it: 'aDestra',
        pt: 'paraADireita',
        ro: 'laDreapta',
        es: 'aLaDerecha',
        tr: 'sağa',
        pl: 'doPrawej',
        ca: 'capalaDreta'
    },
    toTheBottom: {fr: 'versLeBas', en: 'toTheBottom', pl: 'doDołu', ca: 'capAvall'},
    toTheTop: {fr: 'versLeHaut', en: 'toTheTop', pl: 'doGóry', ca: 'capAmunt'},
    square: {
        fr: 'carré',
        en: 'square',
        de: 'quadrat',
        id: 'persegi',
        it: 'quadrato',
        pt: 'quadrado',
        ro: 'pătrat',
        es: 'cuadrado',
        tr: 'kare',
        pl: 'kwadrat',
        ca: 'quadrat'
    },
    jump: {
        fr: 'saute',
        en: 'jump',
        de: 'springe',
        id: 'lompat',
        it: 'saltare',
        pt: 'saltar',
        ro: 'sări',
        es: 'salta',
        tr: 'atla',
        pl: 'skok',
        ca: 'salta'
    },
    run: {
        fr: 'cours',
        en: 'run',
        de: 'lauf',
        id: 'lari',
        it: 'correre',
        pt: 'corre',
        ro: 'alerga',
        es: 'corre',
        tr: 'koşmak',
        pl: 'biegnij',
        ca: 'corre'
    },
    shake: {
        fr: 'remue',
        en: 'shake',
        de: 'bewege',
        id: 'goyang',
        it: 'scuotere',
        pt: 'mexe',
        ro: 'miscati',
        es: 'meneate',
        tr: 'salla',
        pl: 'potrząśnij',
        ca: 'sacseja'
    },
    dance: {
        fr: 'danse',
        en: 'dance',
        de: 'tanz',
        id: 'menari',
        it: 'danza',
        pt: 'dança',
        ro: 'dansați',
        es: 'baila',
        tr: 'dans',
        pl: 'taniec',
        ca: 'balla'
    },
    choreography: {
        fr: 'chorégraphie',
        en: 'choreography',
        de: 'choreographie',
        id: 'koreografi',
        it: 'coreografia',
        pt: 'coreografia',
        ro: 'coregrafie',
        es: 'coreografía',
        tr: 'koreografi',
        pl: 'choreografia',
        ca: 'coreografia'
    },
    choice: {
        fr: 'choix',
        en: 'choice',
        de: 'wahl',
        id: 'pilihan',
        it: 'scelta',
        pt: 'escolha',
        ro: 'alegere',
        es: 'escoge',
        tr: 'seçenek',
        pl: 'wybierz',
        ca: 'tria'
    },
    fromAbove: {
        fr: 'parDessus',
        en: 'fromAbove',
        de: 'vonOben',
        id: 'dariAtas',
        it: 'daSopra',
        pt: 'deCima',
        ro: 'deSus',
        es: 'porArriba',
        tr: 'yukardan',
        pl: 'odGóry',
        ca: 'desDeDalt'
    },
    fromBelow: {
        fr: 'parDessous',
        en: 'fromBelow',
        de: 'vonUnten',
        id: 'dariBawah',
        it: 'daSotto',
        pt: 'deBaixa',
        ro: 'deDesubt',
        es: 'porAbajo',
        tr: 'aşağıdan',
        pl: 'odDołu',
        ca: 'desDeBaix'
    },
    eye: {
        fr: 'oeil',
        en: 'eye',
        de: 'auge',
        id: 'mata',
        it: 'occhio',
        pt: 'olho',
        ro: 'ochi',
        es: 'ojo',
        tr: 'göz',
        pl: 'oko',
        ca: 'ull'
    },
    fall: {
        fr: 'chute',
        en: 'fall',
        de: 'fall',
        id: 'jatuh',
        it: 'cadere',
        pt: 'queda',
        ro: 'cădea',
        es: 'caída',
        tr: 'düşme',
        pl: 'spadanie',
        ca: 'caiguda'
    },
    road: {
        fr: 'route',
        en: 'road',
        de: 'strasse',
        id: 'jalan',
        it: 'strada',
        pt: 'estrada',
        ro: 'drum',
        es: 'camino',
        tr: 'yol',
        pl: 'droga',
        ca: 'carretera'
    },
    bypass: {
        fr: 'déviation',
        en: 'bypass',
        de: 'umgehung',
        id: 'keliling',
        it: 'derivazione',
        pt: 'ignorar',
        ro: 'lateral',
        es: 'desviación',
        tr: 'atlatma',
        pl: 'objazd',
        ca: 'desviament'
    },
    bluePath: {
        fr: 'cheminBleu',
        en: 'bluePath',
        pl: 'niebieskaŚcieżka',
        ca: 'camíBlau'
    },
    thing: {fr: 'truc', en: 'thing', pl: 'coś', ca: 'cosa'}
}


export default {
    pseudoCodeWords,
    otherWords
}

